import { render } from "./AuthApp.vue?vue&type=template&id=089da8e2&scoped=true"
const script = {}

import "./AuthApp.vue?vue&type=style&index=0&id=089da8e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089da8e2"]])

export default __exports__